import apiClient from '@/services/rest-api-vsms/apiClient'

const baseEndpoint = '/feedback'

export const store = async (data) => {
  const response = await apiClient({
    method: 'POST',
    url: baseEndpoint,
    data,
  })

  return response?.data
}

export const checkStatus = async () => {
  const response = await apiClient({
    method: 'GET',
    url: baseEndpoint + '-status',
  })

  return response?.data
}
